import React, { lazy, useEffect, useRef, useState } from "react";
import HttpBaseUrl from "./../../httpservice/common.http.js";

const CategoryLazyLoadImage = ({ dataSrc, alt, ...props }) => {
  const [src, setSrc] = useState(`${HttpBaseUrl.getAssetsPath()}/preload.webp`);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setSrc(dataSrc);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "0px 0px 50px 0px",
        threshold: 0.01,
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  }, [dataSrc]);

  return <img ref={imgRef} data-src={dataSrc} src={src} alt={alt} {...props}/>;
};

export default CategoryLazyLoadImage;
